import { createContext, useContext, useState } from 'react';
import type { ReactNode } from 'react';
import { readDashboardSnapshot } from './dashboard.cache';
import type { DashboardOverview } from './types/dashboard.types';

const DashboardHydrationContext = createContext<DashboardOverview | null>(null);

export function DashboardHydrationBoundary({ children }: { children: ReactNode }) {
  const [initialDashboard] = useState<DashboardOverview | null>(() => readDashboardSnapshot());

  return (
    <DashboardHydrationContext.Provider value={initialDashboard}>
      {children}
    </DashboardHydrationContext.Provider>
  );
}

export function useInitialDashboardSnapshot(): DashboardOverview | null {
  return useContext(DashboardHydrationContext);
}
